import type { Motivation } from '../types/content'

export const motivations: Motivation[] = [
  {
    id: 'relax',
    label: 'Per rilassarti',
    title: 'Regalati una pausa creativa',
    description:
      'Scegli un modello, prepara i colori e goditi il piacere di creare con le tue mani.',
    benefits: [
      'Un momento lontano dagli schermi',
      'Un’attività al tuo ritmo',
      'Una decorazione che parla di te',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/26fe5a67-461e-4634-a986-a185f9a59b49.jpg',
    imageAlt:
      'Mani che dipingono un ramo di foglie con effetto vetrata su un supporto trasparente, accanto a una tazza di tè',
  },
  {
    id: 'regalare',
    label: 'Per regalare',
    title: 'Crea un regalo che parla di te',
    description:
      'Scegli forme e colori pensando alla persona che lo riceverà.',
    benefits: [
      'Colori scelti con cura',
      'Un pezzo realizzato a mano',
      'Il piacere di regalare una tua creazione',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6c8fb521-7948-474d-b1b5-c9cf0a01f102.jpg',
    imageAlt:
      'Piccola placca con effetto vetrata adagiata in una scatola regalo di cartone kraft con un nastro di lino',
  },
  {
    id: 'vendere',
    label: 'Per vendere',
    title: 'Dai forma a una collezione tutta tua',
    description:
      'Vuoi fare un passo in più? Puoi valutare una piccola collezione di oggetti decorativi da proporre. Il prezzo dipende dal supporto, dal tempo di lavorazione e dalle finiture.',
    benefits: [
      'Immaginare una collezione coerente',
      'Curare la presentazione delle tue creazioni',
      'Valutare i costi prima di fissare un prezzo',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ff773ed5-f9ae-4615-8f12-4366f8c0e9e6.jpg',
    imageAlt:
      'Quattro oggetti dipinti con effetto vetrata su un tavolo di legno: un portacandele, un vaso fiorito, una cornice floreale e uno specchio decorato',
    note: 'Il kit insegna la tecnica creativa; non include una formazione sulla vendita. I prezzi mostrati sono solo esempi indicativi e non corrispondono al prezzo del kit.',
    priceTagsTitle: 'Idee da proporre · prezzi indicativi',
    priceTags: [
      { label: 'Portacandele', amount: 12, position: 'top-left' },
      { label: 'Vaso fiorito', amount: 24, position: 'top-right' },
      { label: 'Cornice floreale', amount: 29, position: 'bottom-left' },
      { label: 'Specchio decorato', amount: 39, position: 'bottom-right' },
    ],
  },
]
